import { Resource } from "react-admin";
import DunningIcon from "@mui/icons-material/CreditCardOff";
import { DunningList } from "../lists/dunning/DunningList";
import { DunningBoardHeader } from "../lists/dunning/DunningBoardHeader";
import { useCallback, useState } from "react";
import Board from "../misc/Board";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";

export const ALL_DUNNING_DRIVING_SCHOOLS = "all";
const DRIVING_SCHOOL_ID_PARAM = "drivingSchoolId";

function DunningPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const drivingSchoolId = new URLSearchParams(location.search).get(DRIVING_SCHOOL_ID_PARAM) ?? "";
  const [showPostponed, setShowPostponed] = useState<boolean>(false);
  const setDrivingSchoolId = useCallback(
    (drivingSchoolId: string) => {
      const searchParams = new URLSearchParams(location.search);
      if (drivingSchoolId) {
        searchParams.set(DRIVING_SCHOOL_ID_PARAM, drivingSchoolId);
      } else {
        searchParams.delete(DRIVING_SCHOOL_ID_PARAM);
      }
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        { replace: true },
      );
    },
    [location.pathname, location.search, navigate],
  );
  const header = (
    <DunningBoardHeader
      selectedDrivingSchoolId={drivingSchoolId}
      allDrivingSchoolsId={ALL_DUNNING_DRIVING_SCHOOLS}
      setDrivingSchoolId={setDrivingSchoolId}
      showPostponed={showPostponed}
      setShowPostponed={setShowPostponed}
    />
  );
  if (!drivingSchoolId) {
    return (
      <Board title="Mahnwesen" header={header}>
        <Typography>Bitte wähle eine Fahrschule aus.</Typography>
      </Board>
    );
  }
  return (
    <DunningList
      filter={{
        ...(drivingSchoolId === ALL_DUNNING_DRIVING_SCHOOLS ? {} : { drivingSchoolId }),
        showPostponed,
      }}
      header={header}
      useGlobalCandidateQueries
    />
  );
}

export const dunningResource = (
  <Resource key="dunning" name="dunning" icon={DunningIcon} list={DunningPage} options={{ label: "Mahnwesen" }} />
);
